const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: "512px",
    height: "512px",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142,256A143.715,143.715,0,0,1,271.02,112.781,143.9,143.9,0,0,0,112,256c0,79.4,64.6,144,144,144a144.948,144.948,0,0,0,15-.779C198.62,391.7,142,330.337,142,256Z",
    style: {
      fill: "#d4e1f4"
    },
    "data-original": "#D4E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,412c86.019,0,156-69.981,156-156S342.019,100,256,100A155.836,155.836,0,0,0,100,256C100,342.019,169.981,412,256,412ZM218.428,116.949A144.436,144.436,0,0,1,256,112c79.4,0,144,64.6,144,144S335.4,400,256,400,112,335.4,112,256A144.2,144.2,0,0,1,218.428,116.949Z",
    style: {
      fill: "#2F55D4"
    },
    "data-original": "#0635C9",
    className: "",
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,222a6,6,0,0,0,6,6h65.024a36.6,36.6,0,0,1-36.409,31H206a6.062,6.062,0,0,0-4.121,10.446l71.519,67.6a6,6,0,0,0,8.483-.229,6.068,6.068,0,0,0-.24-8.537L221.085,271h13.53a49.173,49.173,0,0,0,48.524-43H306a6,6,0,0,0,0-12H283.139a50.494,50.494,0,0,0-16.49-31H306a6,6,0,0,0,0-12H206a6,6,0,0,0,0,12h28.615c18.306,0,33.533,14,36.409,31H206A6,6,0,0,0,200,222Z",
    style: {
      fill: "#2F55D4"
    },
    "data-original": "#0635C9",
    className: "",
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.109,458.23A32.157,32.157,0,0,1,189.14,425.3a6,6,0,0,0-10.91-4.41A32.154,32.154,0,0,1,145.3,434.86a6,6,0,0,0-4.41,10.91A32.157,32.157,0,0,1,154.86,478.7a6,6,0,0,0,10.91,4.41A32.17,32.17,0,0,1,198.7,469.14a6,6,0,0,0,4.41-10.91Zm-36.352,6.739a44.048,44.048,0,0,0-7.726-18.212,44.074,44.074,0,0,0,18.212-7.726,44.048,44.048,0,0,0,7.726,18.212A44.074,44.074,0,0,0,166.757,464.969Z",
    style: {
      fill: "#2ECA8B"
    },
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    "data-old_color": "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,96.116a47.954,47.954,0,0,1-37.72-37.72,6,6,0,0,0-11.768,0,47.954,47.954,0,0,1-37.72,37.72,6,6,0,0,0,0,11.768,47.954,47.954,0,0,1,37.72,37.72,6,6,0,0,0,11.768,0,47.954,47.954,0,0,1,37.72-37.72,6,6,0,0,0,0-11.768ZM415,126.751A59.839,59.839,0,0,0,390.249,102,59.839,59.839,0,0,0,415,77.249,59.839,59.839,0,0,0,439.751,102,59.839,59.839,0,0,0,415,126.751Z",
    style: {
      fill: "#2ECA8B"
    },
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    "data-old_color": "#1AE5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.6,375.116a47.954,47.954,0,0,1-37.72-37.72,6,6,0,0,0-11.768,0,47.954,47.954,0,0,1-37.72,37.72,6,6,0,0,0,0,11.768,47.954,47.954,0,0,1,37.72,37.72,6,6,0,0,0,11.768,0,47.954,47.954,0,0,1,37.72-37.72,6,6,0,0,0,0-11.768ZM74,405.751A59.839,59.839,0,0,0,49.249,381,59.839,59.839,0,0,0,74,356.249,59.839,59.839,0,0,0,98.751,381,59.839,59.839,0,0,0,74,405.751Z",
    style: {
      fill: "#2ECA8B"
    },
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    "data-old_color": "#1AE5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.ee8e66010de2c602f25da8448076e82b.svg";
export { ForwardRef as ReactComponent };